<ng-container *ngIf="loggedIn$ | async; else publicNotFound">
  <cigna-layout-secure> <router-outlet> </router-outlet></cigna-layout-secure>
</ng-container>

<ng-template #publicNotFound>
  <cigna-layout-public><router-outlet> </router-outlet> </cigna-layout-public>
</ng-template>
